'use client';

import { c as _c } from "react/compiler-runtime";
import useSWR from 'swr';
import { CACHE_KEYS } from '~/lib/cache';
import { useAuthToken } from '~/lib/hooks';
import { SupportedLocales } from '~/types';
import { getStudentObjectivesCourse, getStudentObjectivesModule, getStudentObjectivesUnit } from './learningObjective.server';
import { getCachedBookmark, getCachedBookmarkedBlocks, getCachedCourseProgressPercentage2, getCachedModuleProgressPercentage, getCachedUnitProgress, getCourseUnitTimeProgress } from './progress.server';
export function useCachedUnitProgressSWR(t0) {
  const $ = _c(11);
  const {
    courseId,
    moduleId,
    unitId,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt || $[2] !== moduleId || $[3] !== unitId) {
    t1 = jwt ? CACHE_KEYS.BLOCK_PROGRESS({
      courseId,
      moduleId,
      unitId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = moduleId;
    $[3] = unitId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== courseId || $[6] !== jwt || $[7] !== unitId) {
    t2 = () => getCachedUnitProgress({
      courseId: Number(courseId),
      unitId: Number(unitId),
      jwt
    });
    $[5] = courseId;
    $[6] = jwt;
    $[7] = unitId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== suspense) {
    t3 = {
      suspense
    };
    $[9] = suspense;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedBookmarkSWR(t0) {
  const $ = _c(13);
  const {
    courseId,
    moduleId,
    unitId,
    blockIdent,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== blockIdent || $[1] !== courseId || $[2] !== jwt || $[3] !== moduleId || $[4] !== unitId) {
    t1 = jwt ? CACHE_KEYS.BOOKMARK({
      courseId,
      moduleId,
      unitId,
      blockIdent
    }) : null;
    $[0] = blockIdent;
    $[1] = courseId;
    $[2] = jwt;
    $[3] = moduleId;
    $[4] = unitId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== blockIdent || $[7] !== courseId || $[8] !== jwt || $[9] !== unitId) {
    t2 = () => getCachedBookmark({
      courseId: Number(courseId),
      unitId: Number(unitId),
      blockIdent,
      jwt
    });
    $[6] = blockIdent;
    $[7] = courseId;
    $[8] = jwt;
    $[9] = unitId;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== suspense) {
    t3 = {
      suspense
    };
    $[11] = suspense;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedBookmarkedBlocksSWR(t0) {
  const $ = _c(8);
  const {
    courseId,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt) {
    t1 = jwt ? CACHE_KEYS.BOOKMARK({
      courseId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== courseId || $[4] !== jwt) {
    t2 = () => getCachedBookmarkedBlocks({
      courseId: Number(courseId),
      jwt
    });
    $[3] = courseId;
    $[4] = jwt;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== suspense) {
    t3 = {
      suspense
    };
    $[6] = suspense;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedModuleCompletionSWR(t0) {
  const $ = _c(11);
  const {
    courseId,
    moduleId,
    locale,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt || $[2] !== moduleId) {
    t1 = jwt ? CACHE_KEYS.BLOCK_PROGRESS({
      courseId,
      moduleId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = moduleId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== courseId || $[5] !== jwt || $[6] !== locale || $[7] !== moduleId) {
    t2 = () => getCachedModuleProgressPercentage({
      courseId: String(courseId),
      moduleId: String(moduleId),
      jwt,
      locale
    });
    $[4] = courseId;
    $[5] = jwt;
    $[6] = locale;
    $[7] = moduleId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== suspense) {
    t3 = {
      suspense
    };
    $[9] = suspense;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedCourseCompletionSWR(t0) {
  const $ = _c(9);
  const {
    courseId,
    locale,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt) {
    t1 = jwt ? CACHE_KEYS.BLOCK_PROGRESS({
      courseId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== courseId || $[4] !== jwt || $[5] !== locale) {
    t2 = () => getCachedCourseProgressPercentage2({
      courseId: String(courseId),
      jwt,
      locale
    });
    $[3] = courseId;
    $[4] = jwt;
    $[5] = locale;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== suspense) {
    t3 = {
      suspense
    };
    $[7] = suspense;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedUnitObjectivesSWR(t0) {
  const $ = _c(13);
  const {
    courseId,
    moduleId,
    unitId,
    locale,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt || $[2] !== moduleId || $[3] !== unitId) {
    t1 = jwt ? CACHE_KEYS.OBJECTIVE_PROGRESS({
      courseId,
      moduleId,
      unitId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = moduleId;
    $[3] = unitId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== courseId || $[6] !== jwt || $[7] !== locale || $[8] !== moduleId || $[9] !== unitId) {
    t2 = () => getStudentObjectivesUnit({
      unitId: String(unitId),
      moduleId: String(moduleId),
      courseId: String(courseId),
      jwt,
      locale
    });
    $[5] = courseId;
    $[6] = jwt;
    $[7] = locale;
    $[8] = moduleId;
    $[9] = unitId;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== suspense) {
    t3 = {
      suspense
    };
    $[11] = suspense;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedModuleObjectivesSWR(t0) {
  const $ = _c(11);
  const {
    moduleId,
    courseId,
    locale,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt || $[2] !== moduleId) {
    t1 = jwt ? CACHE_KEYS.OBJECTIVE_PROGRESS({
      courseId,
      moduleId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = moduleId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== courseId || $[5] !== jwt || $[6] !== locale || $[7] !== moduleId) {
    t2 = () => getStudentObjectivesModule({
      moduleId: String(moduleId),
      courseId: String(courseId),
      locale,
      jwt
    });
    $[4] = courseId;
    $[5] = jwt;
    $[6] = locale;
    $[7] = moduleId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== suspense) {
    t3 = {
      suspense
    };
    $[9] = suspense;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedCourseObjectivesSWR(t0) {
  const $ = _c(9);
  const {
    courseId,
    locale,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt) {
    t1 = jwt ? CACHE_KEYS.OBJECTIVE_PROGRESS({
      courseId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== courseId || $[4] !== jwt || $[5] !== locale) {
    t2 = () => getStudentObjectivesCourse({
      courseId: String(courseId),
      locale,
      jwt
    });
    $[3] = courseId;
    $[4] = jwt;
    $[5] = locale;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== suspense) {
    t3 = {
      suspense
    };
    $[7] = suspense;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSWR(t1, t2, t3);
}
export function useCachedCourseUnitTimeProgressSWR(t0) {
  const $ = _c(9);
  const {
    courseId,
    locale,
    suspense
  } = t0;
  const jwt = useAuthToken();
  let t1;
  if ($[0] !== courseId || $[1] !== jwt) {
    t1 = jwt ? CACHE_KEYS.COURSE_UNIT_TIME_PROGRESS({
      courseId
    }) : null;
    $[0] = courseId;
    $[1] = jwt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== courseId || $[4] !== jwt || $[5] !== locale) {
    t2 = () => getCourseUnitTimeProgress({
      courseId: String(courseId),
      locale,
      jwt
    });
    $[3] = courseId;
    $[4] = jwt;
    $[5] = locale;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== suspense) {
    t3 = {
      suspense
    };
    $[7] = suspense;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSWR(t1, t2, t3);
}